import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: '/',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/Mine',
      name: 'Mine',
      component: () => import('@/views/Mine.vue')
    },
    {
      path: '/Port',
      name: 'Port',
      component: () => import('@/views/Port.vue')
    },
    {
      path: '/TideCalendar',
      name: 'TideCalendar',
      component: () => import('@/views/TideCalendar.vue')
    },
    {
      path: '/MonthTide',
      name: 'MonthTide',
      component: () => import('@/views/MonthTide.vue')
    },

  ]
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router